import { defineMessages } from 'react-intl';

export default defineMessages({
  togglePasswordVisibility: {
    id: 'cboard.components.FormItems.PasswwordTextField.togglePasswordVisibility',
    defaultMessage: 'Toggle password visibility'
  }
});
